// @ts-nocheck
import {createContext,useContext} from "react";

export const AreasContext = createContext({});
export function useAreas() {
    return useContext(AreasContext);
}
